import { ProPilotMessage, ProPilotMessageStatus } from "PFApp/stores/propilot_store";
import { ReactNode, Ref } from "react";

import { ProPilotInput } from "../propilot_input/propilot_input";
import { ProPilotLiveRegion } from "../propilot_live_region";
import { ProPilotMessageList } from "../propilot_message_list/propilot_message_list";
import { ProPilotTypingIndicator } from "../propilot_typing_indicator/propilot_typing_indicator";
import css from "./propilot_conversation.module.scss";

type ProPilotConversationProps = {
  conversationId: string;
  messages: ProPilotMessage[];
  status: ProPilotMessageStatus;
  allowFreeText: boolean;
  isConnected: () => boolean;
  onSubmit: (text: string) => void;
  renderMessage?: (message: ProPilotMessage) => ReactNode;
  inputRef?: Ref<HTMLTextAreaElement>;
};

export const ProPilotConversation = ({
  conversationId,
  messages,
  status,
  allowFreeText,
  isConnected,
  onSubmit,
  renderMessage,
  inputRef
}: ProPilotConversationProps) => (
  <div className={css.contentRegion}>
    <div className={css.conversationBox}>
      <ProPilotMessageList messages={messages} renderMessage={renderMessage} />
      <ProPilotTypingIndicator status={status} />
    </div>
    <ProPilotLiveRegion conversationId={conversationId} />
    <ProPilotInput
      conversationId={conversationId}
      status={status}
      allowFreeText={allowFreeText}
      isConnected={isConnected}
      onSubmit={onSubmit}
      ref={inputRef}
    />
  </div>
);
